import { useState, useEffect } from 'react';
import { ProjectSettings } from '../types';
import { mockProjectSettings } from '../data/mockData';

export const useTheme = () => {
  const [settings, setSettings] = useState<ProjectSettings>(mockProjectSettings);

  useEffect(() => {
    // Apply CSS variables for theme
    const root = document.documentElement;
    root.style.setProperty('--color-primary', settings.theme.primary);
    root.style.setProperty('--color-secondary', settings.theme.secondary);
    root.style.setProperty('--color-accent', settings.theme.accent);
    root.style.setProperty('--color-success', settings.theme.success);
    root.style.setProperty('--color-warning', settings.theme.warning);
    root.style.setProperty('--color-error', settings.theme.error);
  }, [settings.theme]);

  const updateTheme = (newTheme: Partial<ProjectSettings['theme']>) => {
    setSettings(prev => ({
      ...prev,
      theme: { ...prev.theme, ...newTheme }
    }));
  };

  return { settings, updateTheme };
};